import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Spinner, Alert } from "reactstrap";
import axiosInstance from "../../request.jsx"; // your axios config
import { URL } from "../../api.jsx";
import getPrivilegeList from "../../peday/PrivilegeList.jsx";

const BreButton = () => {
  const privilegeList = getPrivilegeList();

  const [schedulerStatus, setSchedulerStatus] = useState(false);
  const [financeStatus, setFinanceStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // ✅ Fetch master scheduler status
  const fetchStatus = () => {
    if (!privilegeList.breMasterToggleView) return;
    setLoading(true);
    axiosInstance.get(URL.STATUS_BRE_BUTTON)
      .then(res => {
        setSchedulerStatus(res.data === "Scheduler is ON");
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setMessage("Failed to fetch scheduler status.");
        setLoading(false);
      });
  };

  // ✅ Fetch finance scheduler status
  const fetchFinanceStatus = () => {
    if (!privilegeList.breFinanceToggleView) return;
    axiosInstance.get(URL.STATUS_BRE_FINANCE)
      .then(res => {
        setFinanceStatus(res.data === "Finance Scheduler is ON");
      })
      .catch(err => {
        console.error(err);
        setMessage("Failed to fetch finance scheduler status.");
      });
  };

  useEffect(() => {
    fetchStatus();
    fetchFinanceStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ Helper to show temporary message
  const showMessage = (msg, duration = 3000) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), duration);
  };

  // ✅ Toggle master scheduler
  const toggleScheduler = () => {
    setLoading(true);
    axiosInstance.post(`${URL.TOGGLE_BRE_BUTTON}?enable=${!schedulerStatus}`)
      .then(res => {
        setSchedulerStatus(!schedulerStatus);
        showMessage(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        showMessage("Failed to toggle scheduler.");
        setLoading(false);
      });
  };

  // ✅ Toggle finance scheduler
  const toggleFinanceScheduler = () => {
    setLoading(true);
    axiosInstance.post(`${URL.TOGGLE_BRE_FINANCE}?enable=${!financeStatus}`)
      .then(res => {
        setFinanceStatus(!financeStatus);
        showMessage(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        showMessage("Failed to toggle finance scheduler.");
        setLoading(false);
      });
  };

  // ✅ Manual run of BRE
  const runNow = () => {
    setLoading(true);
    axiosInstance.post(URL.RUN_NOW_BRE_ALL)
      .then(res => {
        showMessage(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        showMessage("Failed to run BRE manually.");
        setLoading(false);
      });
  };

  return (
    <Card style={{ width: "50%", margin: "20px auto" }}>
      <CardBody>
        <h4>BRE Scheduler Control</h4>
        {loading && <Spinner />}

        {/* Message alert at top */}
        {message && <Alert color="info">{message}</Alert>}

        {/* ============ MASTER SCHEDULER (privilege gated) ============ */}
        {privilegeList.breMasterToggleView && (
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                color={schedulerStatus ? "danger" : "success"}
                onClick={toggleScheduler}
              >
                {schedulerStatus ? "Turn OFF Scheduler" : "Turn ON Scheduler"}
              </Button>

              <Button color="primary" onClick={runNow}>
                Run BRE Manually
              </Button>
            </div>

            <div style={{ marginTop: "10px" }}>
              Current Scheduler Status:{" "}
              <strong>{schedulerStatus ? "ON" : "OFF"}</strong>
            </div>
          </div>
        )}

        {/* ============ FINANCE SCHEDULER (privilege gated) ============ */}
        {privilegeList.breFinanceToggleView && (
          <div style={{ marginTop: "25px", paddingTop: "15px", borderTop: "1px solid #eee" }}>
            <h6>Finance Customer Scheduler</h6>
            <Button
              color={financeStatus ? "danger" : "success"}
              onClick={toggleFinanceScheduler}
            >
              {financeStatus
                ? "Turn OFF Finance Scheduler"
                : "Turn ON Finance Scheduler"}
            </Button>

            <div style={{ marginTop: "10px" }}>
              Current Finance Scheduler Status:{" "}
              <strong>{financeStatus ? "ON" : "OFF"}</strong>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default BreButton;
